import { render, staticRenderFns } from "./collectionSelectContract.vue?vue&type=template&id=542887ca"
import script from "./collectionSelectContract.vue?vue&type=script&lang=js"
export * from "./collectionSelectContract.vue?vue&type=script&lang=js"
import style0 from "./collectionSelectContract.vue?vue&type=style&index=0&id=542887ca&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports